module.exports = "https://deal.freetls.fastly.net/consumer/common/media/step-3.61006c65.mp4";